(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("VuePopup", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["VuePopup"] = factory(require("vue"));
	else
		root["VuePopup"] = factory(root["vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition